import { jwtDecode } from "jwt-decode";
import api from "../Services/api";

const AuthService = {
  login: async (user) => {
    try {
      const loginResponse = await api.post("/auth/login", user, {
        headers: {
          Accept: "application/json",
        },
      });
      if (loginResponse.status === 200) {
        const loginData = loginResponse.data;

        localStorage.setItem("authToken", loginData.data.jwt);

        localStorage.setItem("refreshToken", loginData.data.refreshToken);

        //const token = loginData.data.user.jwt;

        const userDataResponse = await api.post(
          "/auth/me",
          {},
          {
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (userDataResponse.status === 200) {
          const userData = userDataResponse.data.data.user;
          localStorage.setItem("userData", JSON.stringify(userData));
          return { isAuthenticated: true, user: userData };
        } else {
          console.error(
            "Failed to fetch user data from /auth/me:",
            userDataResponse.status
          );
          return { isAuthenticated: false, user: { username: "", role: "" } };
        }
      } else {
        console.error("Login failed with status:", loginResponse.status);
        return { isAuthenticated: false, user: { username: "", role: "" } };
      }
    } catch (error) {
      console.error("Login error:", error);
      return { isAuthenticated: false, user: { username: "", role: "" } };
    }
  },

  isAuthenticated: async () => {
    const token = localStorage.getItem("authToken");
    const refreshToken = localStorage.getItem("refreshToken");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const isExpired = decodedToken.exp < Math.floor(Date.now() / 1000);

        if (isExpired) {
          if (refreshToken) {
            const parsedRefreshToken = JSON.parse(refreshToken);
            const res = await api.post(
              "/auth/refresh-token",
              { refreshToken: parsedRefreshToken },
              {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
              }
            );

            if (res.status === 200) {
              const data = res.data;
              localStorage.setItem("authToken", data.newToken);
              return {
                isAuthenticated: true,
                user: JSON.parse(localStorage.getItem("userData")),
              };
            } else {
              localStorage.removeItem("authToken");
              localStorage.removeItem("refreshToken");
              localStorage.removeItem("userData");
              return {
                isAuthenticated: false,
                user: { username: "", role: "" },
              };
            }
          } else {
            localStorage.removeItem("authToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("userData");
            return {
              isAuthenticated: false,
              user: { username: "", role: "" },
            };
          }
        }

        return {
          isAuthenticated: true,
          user: JSON.parse(localStorage.getItem("userData")),
        };
      } catch (error) {
        console.error("Token decoding error:", error);
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userData");
        return { isAuthenticated: false, user: { username: "", role: "" } };
      }
    } else {
      return { isAuthenticated: false, user: { username: "", role: "" } };
    }
  },

  logout: () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userData");
    return { isAuthenticated: false, user: { username: "", role: "" } };
  },
};

export default AuthService;
